<template>
    <div>
        <b-card no-body>
            <b-overlay class="p-1" :show="loading" opacity="0.2" rounded="sm">
                <div class="d-flex">
                    <flat-pickr v-model="dateRange" class="form-control" :config="{altInput:true, altFormat:'d.m.Y', dateFormat: 'Y-m-d',mode:'range', locale:'tr'}" placeholder="Tarih Aralığı Seçiniz"/>
                    <button class="btn btn-primary ml-1" :disabled="!c_dates.StartDate || !c_dates.EndDate" v-on:click="getStatsProcessType">Raporla</button>
                </div>
            </b-overlay>
        </b-card>
        <div class="row">
            <div class="col-md-4 mb-1">
                <v-stats-box text="Toplam Tutar" short-text="Vergi Hariç" variant="danger" icon="currency_lira" :value="statistics.TotalAmountWithoutTax"></v-stats-box>           
            </div>
            <div class="col-md-4 mb-1">
                <v-stats-box text="Toplam Tutar" short-text="Vergi Dahil" variant="success" icon="currency_lira" :value="statistics.TotalAmount"></v-stats-box>  
            </div>
            <div class="col-md-4 mb-1">
                <v-stats-box text="Toplam Geçiş Sayısı" variant="warning" icon="local_shipping" :value="statistics.TotalCount"></v-stats-box>  
            </div>
        </div>
        <b-card>
            <h4>Günlük Bazda İşlem Tipine Göre İşlem Tutarı</h4>
            <narli-ferryboat-stats-by-process-type-graph :statistics="statistics.TotalStats"></narli-ferryboat-stats-by-process-type-graph>
        </b-card>
        <b-card>
            <h4>Günlük Bazda İşlem Tipine Göre Toplam Geçiş Sayısı</h4>
            <narli-ferryboat-stats-by-process-type-total-graph :statistics="statistics.TotalStats"></narli-ferryboat-stats-by-process-type-total-graph>
        </b-card>
    </div>
</template>

<script>
import { BCard,BOverlay } from "bootstrap-vue";
import flatPickr from 'vue-flatpickr-component'
import ReportsApi from "@/api/reports";
import 'flatpickr/dist/l10n/tr.js' 
import NarliFerryboatStatsByProcessTypeGraph from './components/NarliFerryboatStatsByProcessTypeGraph'
import NarliFerryboatStatsByProcessTypeTotalGraph from './components/NarliFerryboatStatsByProcessTypeTotalGraph'
import VStatsBox from '@/components/VStatsBox.vue'
import moment from 'moment'
export default {
    components:{
        BCard,
        BOverlay,
        flatPickr,
        VStatsBox,
        NarliFerryboatStatsByProcessTypeGraph,
        NarliFerryboatStatsByProcessTypeTotalGraph
    },
    data(){
        return{
            dateRange:null,
            statistics:{
                TotalAmount:null,
                TotalStats:[],
            },
            loading:false,
        }
    },
    mounted(){
        this.dateRange = this.c_month
        this.getStatsProcessType()
    },
    methods:{
        getStatsProcessType(){
            if(this.c_dates.StartDate && this.c_dates.EndDate){
                this.loading = true
                let data = {StartDate:this.c_dates.StartDate,EndDate:this.c_dates.EndDate}
                ReportsApi.NarliFerryboat.ByProcessType(data).then(res=>{
                    if(res.data.Success){
                        this.statistics = res.data.Data
                    }
                    this$result(res)
                    this.loading = false
                }).catch(err=>{
                    this.loading = false
                })
            }
        }
    },
    computed:{
        c_dates(){
            return {
                StartDate : this.dateRange?.split(' - ')[0] || null,
                EndDate : this.dateRange?.split(' - ')[1] || null
            }
        },
        c_month(){
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return [moment(firstDay).format("YYYY-MM-DD"),moment(lastDay).format("YYYY-MM-DD")].join(" - ")
        }
    }
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>